import { Injectable } from '@angular/core';
import Common from '../common/common';

@Injectable({
  providedIn: 'root',
})
export class RolesManageService {
  constructor() {}

  static adminRoles(type: number = 0): any {
    if (type == 0) {
      if (
        Common.userLogin()?.role === Common.rolesManage().adminview ||
        Common.userLogin()?.role === Common.rolesManage().admin ||
        Common.userLogin()?.role === Common.rolesManage().aguser
      ) {
        return true;
      }
    } else if (type == 1) {
      if (Common.userLogin()?.role === Common.rolesManage().adminview) {
        return true;
      }
    }


    return false;
  }

   static clientRoles(type: number = 0): any {
    if (type == 0) {
      if (
        Common.userLogin()?.role === Common.rolesManage().client ||
        Common.userLogin()?.role === Common.rolesManage().clientview ||
        Common.userLogin()?.role === Common.rolesManage().clientusr
      ) {
        return true;
      }
    } else if (type == 1) {
      if (Common.userLogin()?.role === Common.rolesManage().clientview) {
        return true;
      }
    
    } else if (type == 2) {
      if (Common.userLogin()?.role === Common.rolesManage().client) {
        return true;
      }
    }
    return false;
  }

   static centerRoles(type: number = 0): any {
    if (type == 0) {
      if (
        Common.userLogin()?.role === Common.rolesManage().center ||
        Common.userLogin()?.role === Common.rolesManage().centerview ||
        Common.userLogin()?.role === Common.rolesManage().centerusr
      ) {
        return true;
      }
    } else if (type == 1) {
      if (Common.userLogin()?.role === Common.rolesManage().centerview) {
        return true;
      }
    }
    return false;
  }
}
